import * as InternalUtils from "scriptsShared/Utils.js";
import FileInputVue from "./FileInput.vue";
export default {
  name: "v-file-input-form",
  data: function data() {
    return {
      valueInternal: this.value
    };
  },
  computed: {},
  mounted: function mounted() {
    InternalUtils.AssignReactivePropWatches(this);
  },
  props: {
    value: {
      required: true,
      reactive: true
    },
    inputId: {
      type: String,
      required: false
    },
    // data-cy for the inner input; a distinct name so the root's own `data-cy` fallthrough stays unchanged.
    inputDataCy: {
      type: String,
      default: null
    },
    errors: {
      type: Array
    },
    label: {
      type: String,
      required: true
    },
    required: Boolean,
    accept: String,
    description: String
  },
  components: {
    "v-file-input": FileInputVue
  }
};